module.exports = __webpack_public_path__ + "static/media/react.be3668f7.png";